import React from 'react';
import { useEffect } from 'react';
import RegisterForm from './RegisterForm';
import '../gral-stylesheets/register.scss';



const Register = (props) => {

  useEffect(() => {
    props.joinState || props.loginState || props.passwordResetState || props.successState
      ? document.body.style.overflow = 'hidden'
      : document.body.style.overflow = 'unset'
  }, [props.joinState, props.loginState, props.passwordResetState, props.successState]);

  if (!props.joinState) {
    return null
  }
  return (
    <div
      className='modal-container-overlay'
      onClick={props.joinClose}
    >
      <div 
        className='register-box'
        onClick={ (e) => e.stopPropagation() }
        >
        <div className='register-header'>
          <div className='register-title'>
            <h3>Register</h3>
          </div>
          <h4>Join to DearHR, <br /> we appreciate your trust in us</h4>
        </div>
        <RegisterForm
          joinState={props.joinState}
          joinClose={props.joinClose}
          toLogin={props.toLogin}
          successOpen={props.successOpen}
        />
      </div>
    </div>
  )
}

export default Register;